import React from 'react'
import { SectionHeading } from '../Headers'
import { Box } from '../Layout'
import { CardSwiper } from '../CardSwiper'
import { sponsorList } from '../../Utils'
import { SponsorItem } from './SponsorItem'
import { Divider } from '../Layout/Spacers/Spacers.styles'
import { colors } from '../consts'

export const SponsorSection: React.FC<React.PropsWithChildren<unknown>> = () => {
  const filterSponsorList = (sponsorType: string) => {
    let sponsors = [...sponsorList]
    return sponsors.filter((sp) => sp.sponsorType === sponsorType)
  }
  const officialPartners = filterSponsorList('official')
  const proudPartners = filterSponsorList('proud')

  return (
    <Box>
      {officialPartners.length > 0 && (
        <>
          <SectionHeading headingText="Official Partners" />
          <CardSwiper
            items={officialPartners.map((sponsor) => (
              <SponsorItem sponsor={sponsor} />
            ))}
            idx={'0'}
            desktopWidth={220}
            tabletWidth={220}
            mobileWidth={150}
            smMobileWidth={130}
            noMargin
          />
          <Divider color={colors.white} h={2} />
        </>
      )}
      {proudPartners.length > 0 && (
        <>
          <SectionHeading headingText="Proud Partners" />
          <CardSwiper
            items={proudPartners.map((sponsor) => (
              <SponsorItem sponsor={sponsor} />
            ))}
            idx={'0'}
            desktopWidth={180}
            tabletWidth={180}
            mobileWidth={120}
            smMobileWidth={100}
            noMargin
          />
        </>
      )}
    </Box>
  )
}
